import { render } from "./AccountInfo.vue?vue&type=template&id=f12fd492&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"

import "./AccountInfo.vue?vue&type=style&index=0&id=f12fd492&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12fd492"]])

export default __exports__